import Swiper, { Autoplay, FreeMode, Lazy, Keyboard, EffectFade } from 'swiper';

Swiper.use([Autoplay, FreeMode, Lazy, Keyboard, EffectFade]);


//---------------------------//
// slider logo
//---------------------------//


const sliderLogo = () => {
    const sliderLogo = document.querySelectorAll('.swiper-logo');

    if (sliderLogo) {

        
        sliderLogo.forEach(sliderLogo => {
          
            let sumSlideWidth = 0;
            const widthTotal = sliderLogo.offsetWidth;
            const slides = sliderLogo.querySelectorAll('.swiper-slide');
           
            slides.forEach(slide => {
                sumSlideWidth += slide.offsetWidth;
            })

            let loop = false;
            let autoplay = false;

            if( sumSlideWidth > widthTotal){
                loop = true;
                autoplay = {
                    delay: 0,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                }
            }else{
                loop = false;
                sliderLogo.classList.add('justify-content-center')
            }

         
            new Swiper(sliderLogo, {
                // Optional parameters
                loop: loop,
                freeMode: {
                    enabled: true,
                    momentumBounce: false
                },
                grabCursor: true,
                slidesPerView: 'auto',
                centeredSlides: false,
                speed: 4000,
                autoplay: autoplay,
           })
        });
    }

}

export default sliderLogo;
